import React from 'react';
import { Button, Dialog, Text, TextTypography } from '@wix/wix-ui-tpa/cssVars';
import { useExpressCheckoutButtonsProps } from '../../provider/useExpressCheckoutButtonsProps';
import { translate } from '../../utils/translate';
import { classes } from './ExpressCheckoutErrorModal.st.css';
import { getExpressCheckoutModalParams } from './ExpressCheckoutErrorModal.utils';
export let ExpressCheckoutErrorModalDataHooks = /*#__PURE__*/function (ExpressCheckoutErrorModalDataHooks) {
  ExpressCheckoutErrorModalDataHooks["Root"] = "ExpressCheckoutErrorModal.Root";
  ExpressCheckoutErrorModalDataHooks["Title"] = "ExpressCheckoutErrorModal.Title";
  ExpressCheckoutErrorModalDataHooks["Body"] = "ExpressCheckoutErrorModal.Body";
  ExpressCheckoutErrorModalDataHooks["ActionButton"] = "ExpressCheckoutErrorModal.ActionButton";
  return ExpressCheckoutErrorModalDataHooks;
}({});
export const ExpressCheckoutErrorModal = _ref => {
  let isOpen = _ref.isOpen,
    modalType = _ref.modalType,
    onClose = _ref.onClose;
  const data = useExpressCheckoutButtonsProps();
  const translations = data.translations,
    upgradeUrl = data.upgradeUrl,
    shippingSettingsUrl = data.shippingSettingsUrl;
  const t = key => translate(translations, key);
  const _getExpressCheckoutMo = getExpressCheckoutModalParams({
      modalType,
      upgradeUrl,
      shippingSettingsUrl,
      onClose
    }),
    titleKey = _getExpressCheckoutMo.titleKey,
    bodyKey = _getExpressCheckoutMo.bodyKey,
    buttonKey = _getExpressCheckoutMo.buttonKey,
    onAction = _getExpressCheckoutMo.onAction;
  return /*#__PURE__*/React.createElement(Dialog, {
    "data-hook": ExpressCheckoutErrorModalDataHooks.Root,
    isOpen: isOpen,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement(Text, {
    "data-hook": ExpressCheckoutErrorModalDataHooks.Title,
    typography: TextTypography.largeTitle
  }, t(titleKey)), /*#__PURE__*/React.createElement(Text, {
    "data-hook": ExpressCheckoutErrorModalDataHooks.Body,
    typography: TextTypography.runningText
  }, t(bodyKey))), /*#__PURE__*/React.createElement(Button, {
    "data-hook": ExpressCheckoutErrorModalDataHooks.ActionButton,
    className: classes.button,
    onClick: onAction
  }, t(buttonKey))));
};
//# sourceMappingURL=ExpressCheckoutErrorModal.js.map